/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserInteractionListSchema } from './UserInteractionListSchema';
import {
    UserInteractionListSchemaFromJSON,
    UserInteractionListSchemaFromJSONTyped,
    UserInteractionListSchemaToJSON,
} from './UserInteractionListSchema';

/**
 * 
 * @export
 * @interface PagedUserInteractionListSchema
 */
export interface PagedUserInteractionListSchema {
    /**
     * 
     * @type {Array<UserInteractionListSchema>}
     * @memberof PagedUserInteractionListSchema
     */
    items: Array<UserInteractionListSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedUserInteractionListSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedUserInteractionListSchema interface.
 */
export function instanceOfPagedUserInteractionListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedUserInteractionListSchemaFromJSON(json: any): PagedUserInteractionListSchema {
    return PagedUserInteractionListSchemaFromJSONTyped(json, false);
}

export function PagedUserInteractionListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedUserInteractionListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(UserInteractionListSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedUserInteractionListSchemaToJSON(value?: PagedUserInteractionListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(UserInteractionListSchemaToJSON)),
        'count': value.count,
    };
}

